import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "sonner";
import { MessagesSquare } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useLive } from "@/lib/useLive";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { ChatThread } from "@/components/ChatThread";

export default function MyMessages() {
  const { user } = useAuth();
  const [msgs, setMsgs] = useState(null);
  const load = () => api.get("/messages").then((r) => { setMsgs(r.data); window.dispatchEvent(new Event("vt-messages-read")); }).catch(() => setMsgs([]));
  useEffect(() => {
    if (!user || user.role === "super_admin") { return undefined; }
    load();
    return undefined;
  }, [user]); // eslint-disable-line
  useLive(load, 5000, !!user && user.role !== "super_admin");
  if (user === false || user === null) return <Navigate to="/login?next=/mensajes" replace />;
  if (user?.role === "super_admin") return <Navigate to="/admin?tab=mensajes" replace />;
  const send = async (text) => {
    try { const { data } = await api.post("/messages", { text }); setMsgs((m) => [...(m || []), data]); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); throw e; }
  };
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8" data-testid="my-messages-page">
      <div className="flex items-center gap-3 mb-5">
        <span className="grid place-items-center w-11 h-11 rounded-xl bg-primary text-primary-foreground"><MessagesSquare className="w-6 h-6" /></span>
        <div>
          <h1 className="text-2xl font-extrabold tracking-tight">Mensajes</h1>
          <p className="text-sm text-muted-foreground">Conversa directamente con el equipo de VIVOTaller</p>
        </div>
      </div>
      <Card className="overflow-hidden h-[65vh] min-h-[420px]">
        <ChatThread messages={msgs} mine="user" otherLabel="Equipo VIVOTaller" onSend={send} testId="my-chat"
          empty="Aún no hay mensajes. Escríbenos si tienes dudas, sugerencias o necesitas ayuda." />
      </Card>
    </div>
  );
}
